import utilities = require("./utilities");
import * as routes from "./routes";

window.addEventListener("load", async (evt) => {
    evt.preventDefault();
    routes.start();
});